// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#MarkupImage[data-v-773cd7a2]{width:100%;height:calc(100% - 60px);position:relative;top:30px}#MarkupImage #bg[data-v-773cd7a2]{height:100%;width:100%}#MarkupImage #bg[data-v-773cd7a2],#MarkupImage #drawing[data-v-773cd7a2]{position:absolute;left:0;top:0}", ""]);
// Exports
module.exports = exports;
